// ORDER TYPES OPTIONS  
export const ORDER_TYPE_LIMIT                   = "Limit";
export const ORDER_TYPE_MARKET                  = "Market";
export const ORDER_TYPE_STOP_LOSS               = "Stop Loss";
export const ORDER_TYPE_STOP_LIMIT              = "Stop Limit";
export const ORDER_TYPE_TAKE_PROFIT_LIMIT       = "Take Profit Limit";

export const LIMIT_ORDER_TYPES = [
    ORDER_TYPE_LIMIT,
    ORDER_TYPE_STOP_LOSS,
    ORDER_TYPE_STOP_LIMIT,
    ORDER_TYPE_TAKE_PROFIT_LIMIT
];

export const ORDER_TYPE_TO_ENDPOINT_SUFFIX = {
    [ORDER_TYPE_LIMIT]              : "limit",
    [ORDER_TYPE_MARKET]             : "market",
    [ORDER_TYPE_STOP_LOSS]          : "stop_loss",
    [ORDER_TYPE_STOP_LIMIT]         : "stop_limit",
    [ORDER_TYPE_TAKE_PROFIT_LIMIT]  : "take_profit_limit"
};

export const TRIGGER_PRICE_ENABLED_ORDER_TYPES  = [
    ORDER_TYPE_STOP_LOSS,
    ORDER_TYPE_STOP_LIMIT,
    ORDER_TYPE_TAKE_PROFIT_LIMIT
];
// TIME IN FORCE OPTIONS 
export const TIF_DAY                 = "Day";
export const TIF_NA                  = "N/A";
export const TIF_GOOD_TILL_CANCELLED = "Good 'Til Canceled";
export const TIF_CUSTOM              = "Custom";
// DEFAULT PRECISION VALUES
export const DEFAULT_PRECISION = 6;
export const DOLLAR_PRECISION  = 2;
export const MAX_PRECISION     = 8;
// Currency Input Options
export const DOLLAR_DENOMINATION = "dollar";
export const LIMIT_PRICE_OPTIONS = "limit";
export const CRYPTO_DENOMINATION = "crypto";
// Dollar
export const dollarOptions = {
    locale: "en-US",
    currency: "USD",
    currencyDisplay: "symbol",
    valueRange: {
      min: 0,
      max: 1000000000,
    },
    precision: DOLLAR_PRECISION,
    hideCurrencySymbolOnFocus: false,
    hideGroupingSeparatorOnFocus: false,
    hideNegligibleDecimalDigitsOnFocus: true,
    autoDecimalDigits: false,
    exportValueAsInteger: false,
    autoSign: true,
    useGrouping: true,
};
// Limit Price - Different Object to Force Reactive (maybe use lodash instead; Find better way for this)
export const limitPriceOptions = {
    locale: "en-US",
    currency: "USD",
    currencyDisplay: "symbol",
    valueRange: {
      min: 0,
      max: 1000000000,
    },
    precision: DEFAULT_PRECISION,
    hideCurrencySymbolOnFocus: false,
    hideGroupingSeparatorOnFocus: false,
    hideNegligibleDecimalDigitsOnFocus: false,
    autoDecimalDigits: false,
    exportValueAsInteger: false,
    autoSign: true,
    useGrouping: true,
};
// Crypto Asset
export const cryptoOptions = {
    locale: undefined,
    currency: "USD",
    currencyDisplay: "hidden",
    valueRange: {
      min: 0,
      max: undefined,
    },
    precision: DEFAULT_PRECISION,
    hideCurrencySymbolOnFocus: true,
    hideGroupingSeparatorOnFocus: true,
    hideNegligibleDecimalDigitsOnFocus: true,
    autoDecimalDigits: false,
    exportValueAsInteger: false,
    autoSign: true,
    useGrouping: true,
};
// Trading Directions
export const DIRECTION_BUY  = "buy";
export const DIRECTION_SELL = "sell";

// Total Field Text
export const TOTAL_APPROX_COST_TEXT = "Total Approx. Cost";
export const TOTAL_APPROX_PROCEEDS_TEXT = "Total Approx. Proceeds";

// Preview and Confirmation Modal Text
export const TRIGGER_TEXT = "Trigger";
export const LIMIT_TEXT = "Limit";

// Input Types
export const INPUT_TO_AMOUNT   = "toAmount";
export const INPUT_FROM_AMOUNT = "fromAmount";
export const INPUT_LIMIT_PRICE = "limitOrderPrice";

export const CLEARING_TRADE_INVALID_QUOTE_ID        = "";
export const CLEARING_TRADE_INVALID_ONRAMP_PRICE    = 0;
export const USD_CURRENCY_TEXT                      = "USD";

export const ORDER_STATUS_OPEN       = "Open";
export const ORDER_STATUS_CANCELLED  = "Canceled";
export const ORDER_STATUS_EXPIRED    = "Expired";
export const ORDER_STATUS_FAILED     = "Failed";
export const ORDER_STATUS_PENDING    = "Pending";
